import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
// import Hello from '@/components/Hello'
// import Room from '@/components/Room'
import RoomTypeAll from '@/components/RoomTypeAll'
import RoomType from '@/components/RoomTypeV2'
// import Know from '@/components/Know'
// import Travel from '@/components/Travel'
// import Contact from '@/components/Contact'
import Transport from '@/components/Transport'
import Preknow from '@/components/Preknow'
import Regulation from '@/components/Regulation'
import QA from '@/components/QA'
import News from '@/components/News'
import NewsDetail from '@/components/NewsDetail'
import NotFound from '@/components/NotFound'

Vue.use(Router)

const router = new Router({
  // base: '/', // /v2/
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Index
    },
    // {
    //   path: '/room',
    //   name: 'Room',
    //   component: Room
    // },
    {
      path: '/roomType/:id',
      name: 'RoomType',
      component: RoomType
    },
    {
      path: '/RoomTypeAll',
      name: 'RoomTypeAll',
      component: RoomTypeAll
    },
    {
      path: '/know',
      name: 'Know',
      component: Preknow
    },
    {
      path: '/regulation',
      name: 'Regulation',
      component: Regulation
    },
    {
      path: '/QA',
      name: 'QA',
      component: QA
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Transport
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/news/:id',
      name: 'NewsDetail',
      component: NewsDetail
    },
    // {
    //   path: '/travel',
    //   name: 'Travel',
    //   component: Travel
    // },
    {
      path: '/*',
      name: '404',
      component: NotFound
    }
  ],
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      setTimeout(() => {
        const element = document.getElementById(to.hash.replace(/#/, ''))
        if (element && element.scrollIntoView) {
          element.scrollIntoView({block: 'end', behavior: 'smooth'})
        }
      }, 500)

      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

// router.beforeEach((to, from, next) => {
//   window.scrollTo(0, 0)
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js